import { ReactNode, useState } from 'react';

import { HomepageRedirectContext } from '../hooks/useHomepageRedirect';

const DISABLE_REDIRECT_PARAM = 'disable-homepage-redirect';

/**
 * Owns the homepage-redirect-enabled state. Rendered by `FrameworkProvider`,
 * wrapping `JwtUrlLogin`, so `JwtUrlLogin` can disable redirect when the page
 * was loaded via a `?jwt=` URL parameter. A `?disable-homepage-redirect`
 * parameter present at load disables it for the page's lifetime.
 */
export function HomepageRedirectProvider({
  children,
}: {
  children: ReactNode;
}): ReactNode {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const envRedirectUrl = import.meta.env.VITE_HOMEPAGE_REDIRECT_URL;
  const [disabledByParam] = useState(() =>
    new URLSearchParams(window.location.search).has(DISABLE_REDIRECT_PARAM),
  );
  const redirectUrl =
    envRedirectUrl && !disabledByParam ? String(envRedirectUrl) : undefined;
  const [redirectEnabled, setRedirectEnabled] = useState(true);

  return (
    <HomepageRedirectContext.Provider
      value={{
        redirectUrl,
        redirectEnabled,
        setRedirectEnabled,
      }}
    >
      {children}
    </HomepageRedirectContext.Provider>
  );
}
